var map = {
	"./img/PayBill.png": 17283,
	"./img/Virtual-side-Banner.png": 95968,
	"./img/airtelmoney.png": 16247,
	"./img/banner/CashBack.png": 43031,
	"./img/banner/Live-Betting.png": 37347,
	"./img/banner/Welcome-Bonus.png": 721,
	"./img/banner/jackpots/DailyJackpot.png": 56060,
	"./img/banner/print-matches/Footer.png": 38346,
	"./img/banner/print-matches/Header.png": 98084,
	"./img/banner/products/CashBack.png": 99436,
	"./img/banner/products/Deposit-Bonus.png": 41634,
	"./img/banner/products/JackPot.png": 14992,
	"./img/banner/products/Live-Betting.png": 56392,
	"./img/banner/products/Mshipi-Bonus.png": 63102,
	"./img/banner/products/Welcome-Bonus.png": 41432,
	"./img/bpl.png": 23312,
	"./img/brazil.png": 50718,
	"./img/bundesliga.png": 59488,
	"./img/clock.png": 67612,
	"./img/flags-1-1/hipo.png": 60322,
	"./img/flags-1-1/sure.png": 4035,
	"./img/france.png": 27205,
	"./img/germany.png": 17129,
	"./img/hipo.png": 56682,
	"./img/iceland.png": 42036,
	"./img/italy.png": 64319,
	"./img/laliga.png": 24364,
	"./img/logo.png": 65549,
	"./img/logo2.png": 93131,
	"./img/mobile/APPDownload.png": 17702,
	"./img/mpesa-1.png": 11396,
	"./img/mpesa-3.png": 69718,
	"./img/mpesa.png": 87806,
	"./img/norway.png": 33566,
	"./img/padlock.png": 96348,
	"./img/rugby-mobile.png": 61804,
	"./img/rugby.png": 26295,
	"./img/seriea.png": 86457,
	"./img/spain.png": 86209,
	"./img/sure.png": 50363,
	"./img/todays.png": 66046,
	"./img/ucl.png": 74566,
	"./img/uefa.png": 3769,
	"./svg/hipo.png": 94327,
	"./svg/sure.png": 51354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72014;